import { t } from "i18next";
import * as z from "zod";

import {
  NOTIFICATION_CHANNELS,
  NOTIFICATION_LANGUAGES,
} from "@/features/shared/api/enums";

/**
 * Schéma du formulaire création/édition d'un modèle de notification
 * (`POST /NotificationTemplates/add`) — le tuple `(code, channel, language)`
 * identifie l'entrée, `bodyTemplate` porte le contenu (variables substituées
 * à l'envoi).
 *
 * Factory (règle projet) : créé via `createNotificationTemplateSchema()` et
 * mémoïsé au niveau composant sur la langue courante — jamais d'instance
 * figée. Les valeurs d'énumérations viennent de l'annexe A.
 */
export const createNotificationTemplateSchema = () =>
  z.object({
    code: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .regex(/^[A-Z][A-Z0-9_]*$/, { message: t("invalidFieldError") }),
    channel: z.enum(NOTIFICATION_CHANNELS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    language: z.enum(NOTIFICATION_LANGUAGES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    subject: z.string().trim().or(z.literal("")),
    bodyTemplate: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    isActive: z.boolean(),
  });

export type NotificationTemplateFormValues = z.infer<
  ReturnType<typeof createNotificationTemplateSchema>
>;
